import React from 'react'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import FormHelperText from '@mui/material/FormHelperText'
import { makeStyles, useTheme } from '@mui/styles';
import { Trans } from 'react-i18next'
import ReactCodeInput from 'react-code-input';
import {
    hiddenPhone
} from 'helpers/utils'
import dataStorage from 'dataStorage'
import {
    useGetPhoneOTP
} from 'hooks/useOTP'
import {
    useVerifyPhoneNumber
} from 'hooks/useAuth'
import Close from '@mui/icons-material/Close'
import styled from '@emotion/styled'

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(2)
    }
}))

const BtnClose = styled.span`
    position:absolute ;
    top:10px;
    right:10px;
`;

const OTP_LENGTH = 6

const getRestCount = (phone) => {
    phone = phone.replace(/\|/, '')
    if (dataStorage.timeSendOTP[phone]) {
        const restTime = 60000 - (Date.now() - dataStorage.timeSendOTP[phone])
        if (restTime > 0) return Math.round(restTime / 1000)
        else return 0
    } else return 0
}

const VerifyPhoneNumber = ({ phone, callback, close }) => {
    const theme = useTheme()
    const classes = useStyles()
    const pinRef = React.useRef()
    const [error, setError] = React.useState('')
    const { mutate: verifyPhoneOTP } = useVerifyPhoneNumber()
    const { mutate: requestPhoneOTP } = useGetPhoneOTP()
    const [count, setCount] = React.useState()
    const intervalId = React.useRef(null)

    React.useEffect(() => {
        const restCount = getRestCount(phone)
        if (restCount) {
            startCount(restCount)
        } else {
            window.grecaptcha.ready(function () {
                window.grecaptcha.execute('6Ld3_w8dAAAAAHDKxfB09-Y6lSbYhvZji5XB0z9r', { action: 'submit' }).then(function (token) {
                    requestPhoneOTP({ phone: (phone + '').replace(/\|/g, ''), recaptchaToken: token }, {
                        onSuccess: () => startCount(),
                        onError: (error) => {
                            dataStorage.showAlert(error)
                        }
                    })
                });
            });
        }
        return () => {
            clearInterval(intervalId.current)
        }
    }, [])

    const onChangeOTP = otp => {
        if (otp.length === OTP_LENGTH) {
            window.grecaptcha.ready(function () {
                window.grecaptcha.execute('6Ld3_w8dAAAAAHDKxfB09-Y6lSbYhvZji5XB0z9r', { action: 'submit' }).then(function (token) {
                    verifyPhoneOTP({
                        otpCode: otp,
                        phoneNumber: (phone + '').replace(/\|/g, '')
                    }, {
                        onSuccess: (response) => {
                            callback?.(response)
                            close?.()
                        },
                        onError: (error) => {
                            clearPin()
                            console.error('verify phone OTP error: ', error)
                            dataStorage.showAlert(error)
                        },
                    })
                });
            });
        }
    };

    const clearPin = () => {
        if (pinRef.current.textInput[0]) pinRef.current.textInput[0].focus()
        pinRef.current.state.input[0] = ''
        pinRef.current.state.input[1] = ''
        pinRef.current.state.input[2] = ''
        pinRef.current.state.input[3] = ''
        pinRef.current.state.input[4] = ''
        pinRef.current.state.input[5] = ''
    }

    React.useEffect(() => {
        if (count === 0) {
            clearInterval(intervalId.current)
        }
    }, [count])

    const startCount = (initCount = 60) => {
        setCount(initCount)
        intervalId.current && clearInterval(intervalId.current)
        intervalId.current = setInterval(() => {
            setCount(old => old - 1)
        }, 1000);
    }

    const onResend = () => {
        clearPin()
        window.grecaptcha.ready(function () {
            window.grecaptcha.execute('6Ld3_w8dAAAAAHDKxfB09-Y6lSbYhvZji5XB0z9r', { action: 'submit' }).then(function (token) {
                requestPhoneOTP({ phone: (phone + '').replace(/\|/g, ''), recaptchaToken: token }, {
                    onSuccess: () => startCount(),
                    onError: (error) => {
                        dataStorage.showAlert(error)
                    }
                })
            });
        });
    }

    return (
        <Grid container spacing={3} className={classes.container}>
            <BtnClose onClick={() => {
                close?.();
            }}>
                <Close />
            </BtnClose>
            <Grid item xs={12} textAlign='center'>
                <Typography variant='body2'>
                    <Trans
                        components={[<strong />]}
                        values={{ phone: hiddenPhone(phone) }}>
                        lang_phone_verification_code_send_noti
                    </Trans>
                </Typography>
            </Grid>
            <Grid item xs={12} textAlign='center'>
                <ReactCodeInput
                    id="phoneCode"
                    type="number"
                    name={'verify_phone_otp'}
                    className="ReactCodeInput"
                    isValid={!error}
                    fields={OTP_LENGTH}
                    pattern="[0-9]*"
                    inputmode="numeric"
                    onChange={onChangeOTP}
                    ref={pinRef}
                    inputStyle={{
                        outline: 'none',
                        margin: 4,
                        width: 'calc((100% - 48px) / 6)',
                        maxWidth: 48,
                        height: 48,
                        borderRadius: 4,
                        fontSize: 32,
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                        border: `1px solid ${theme.palette.grey[500]}`,
                        textAlign: 'center'
                    }}
                    inputStyleInvalid={{
                        outline: 'none',
                        margin: 4,
                        width: 'calc((100% - 48px) / 6)',
                        maxWidth: 48,
                        height: 48,
                        borderRadius: 4,
                        fontSize: 32,
                        backgroundColor: theme.palette.background.paper,
                        color: theme.palette.text.primary,
                        border: `1px solid ${theme.palette.error.main}`,
                        textAlign: 'center'
                    }}
                />
            </Grid>
            {
                error
                    ? <Grid item xs={12} textAlign='center'>
                        <FormHelperText error style={{ textAlign: 'center' }}><Trans>lang_wrong_otp</Trans></FormHelperText>
                    </Grid>
                    : <React.Fragment />
            }
            <Grid item xs={12}>
                <Typography variant='body2'>
                    <Trans
                        values={{ count: count ? `(${count}s)` : '' }}
                        components={[<Link component='button' style={{ opacity: count ? 0.6 : 1 }} variant='body2' disabled={!!count} onClick={onResend} />, <Link href='#' target='_blank' />]}>
                        lang_if_dont_receive_phone_verification_code
                    </Trans>
                </Typography>
            </Grid>
        </Grid>
    )
}

export default VerifyPhoneNumber